module.exports = __webpack_public_path__ + "static/media/suns-team.86841993.jpg";